import { StyleSheet } from "aphrodite";
import theme from "../../../common/theme/mellon";

export default StyleSheet.create({
    footerContainer: {
        width: "100%",
        backgroundColor: theme.palette.primary.main,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        paddingTop: "20px",
        paddingBottom: "20px",
        marginTop: "auto",
    },
    footerContainerMobile: {
        width: "100%",
        backgroundColor: theme.palette.primary.main,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        paddingTop: "15px",
        paddingBottom: "15px",
        marginTop: "auto",
    },
    content: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "12px",
    },
    text: {
        color: theme.palette.common.white,
        textAlign: "center",       
        fontSize: "0.875rem",
    },
    textMobile: {
        color: theme.palette.common.white,
        textAlign: "center",       
        fontSize: "0.75rem",
    },
    linksContainer: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "8px",
    },
    linksContainerMobile: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "6px",
    },
    link: {
        color: theme.palette.common.white,
        fontSize: "0.875rem",
        cursor: "pointer",
        transition: "color 0.2s ease",
        "&:hover": {
            color: theme.palette.secondary.main,
        },
    },
    linkMobile: {
        color: theme.palette.common.white,
        fontSize: "0.75rem",
        cursor: "pointer",
        transition: "color 0.2s ease",
        "&:hover": {
            color: theme.palette.secondary.main,
        },
    },
    linkDivider: {
        height: "14px",
        border: `1px solid ${theme.palette.common.white}`,
        opacity: 0.5,
    },
});
